<template>
  <div class="user-manage-page">
    <management-table
      title="账号管理"
      eyebrow="User Manage"
      table-class="user-index-table"
      :data="tableData"
      :loading="loading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="total"
      empty-text="暂无账号数据"
      @current-change="onPageChange"
    >
      <template slot="filters">
        <div class="search-item">
          <label class="search-label">名称:</label>
          <el-input
            v-model.trim="query.userName"
            class="search-input"
            clearable
            placeholder="请输入名称搜索"
            @keyup.enter.native="serch"
          />
        </div>
      </template>

      <template slot="actions">
        <el-button type="primary" icon="el-icon-search" class="search-btn" :loading="loading" @click="serch">查询</el-button>
        <el-button v-if="canEdit === 1" type="primary" icon="el-icon-plus" class="add-btn" @click="addUser">添加</el-button>
      </template>

      <template slot="columns">
        <el-table-column type="index" width="50" label="序号" />
        <el-table-column show-overflow-tooltip label="名称" prop="userName" />
        <el-table-column label="账户" prop="account" />
        <el-table-column label="手机号码" prop="userMobile" />
        <el-table-column label="邮箱" prop="userEmail" />
        <el-table-column label="权限" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.canEdit === 2" type="info" size="small">只读</el-tag>
            <el-tag v-else type="success" size="small">读写</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="userLevel === 1" label="价格" prop="priceOfMoney" />
        <el-table-column width="90" fixed="right" label="操作">
          <template slot-scope="scope">
            <span class="opt-btn view-btn" @click="openUserEdit(scope.row)">查看</span>
            <span
              v-if="canEdit === 1 && scope.row.createUserId > 1"
              class="opt-btn del-btn"
              @click="doDelete(scope.row.id)"
            >删除</span>
          </template>
        </el-table-column>
      </template>
    </management-table>

    <el-dialog
      :visible.sync="showInfo"
      @closed="resetForm"
      width="560px"
      top="8vh"
      :close-on-click-modal="false"
      custom-class="user-edit-dialog"
    >
      <div slot="title" class="dialog-heading">
        <strong>{{ formObject.id ? '编辑账号' : '添加账号' }}</strong>
      </div>

      <div class="form-content">
        <section class="form-panel">
          <div class="section-heading">
            <span>基本信息</span>
          </div>
          <el-form :model="formObject" label-position="top" class="user-form" :disabled="canEdit !== 1">
            <div class="form-grid">
              <el-form-item label="名称" required>
                <el-input v-model="formObject.userName" prefix-icon="el-icon-user" placeholder="请输入名称" />
              </el-form-item>
              <el-form-item label="用户名" required>
                <el-input v-model="formObject.account" prefix-icon="el-icon-s-custom" placeholder="请输入用户名" />
              </el-form-item>
              <el-form-item label="手机号" required>
                <el-input v-model="formObject.userMobile" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号" />
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input v-model="formObject.userEmail" prefix-icon="el-icon-message" placeholder="请输入邮箱" />
              </el-form-item>
              <el-form-item
                v-if="userLevel < 3 && formObject.createUserId == 1"
                label="价格"
              >
                <el-input v-model="formObject.priceOfMoney" prefix-icon="el-icon-coin" placeholder="请输入价格">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="密码" :required="!formObject.id">
                <el-input
                  v-model="formObject.userNewPass"
                  prefix-icon="el-icon-lock"
                  type="password"
                  show-password
                  autocomplete="new-password"
                  :placeholder="formObject.id ? '留空则不修改密码' : '请输入密码'"
                />
              </el-form-item>
              <el-form-item v-if="!formObject.id" label="再次输入密码" required>
                <el-input
                  v-model="formObject.userNewPassConfirm"
                  prefix-icon="el-icon-lock"
                  type="password"
                  show-password
                  autocomplete="new-password"
                  placeholder="请再次输入密码"
                />
              </el-form-item>
              <el-form-item
                v-if="canSetPermission"
                label="账号权限"
                class="permission-form-item"
              >
                <el-radio-group v-model="formObject.canEdit" class="permission-radio-group">
                  <el-radio :label="1">读写</el-radio>
                  <el-radio :label="2">只读</el-radio>
                </el-radio-group>
                <div class="permission-tip">只读账号可查看当前账号的数据，但不能新增、修改或删除。</div>
                <div v-if="formObject.id" class="permission-tip">账号自身存在业务数据时，不能从读写切换为只读；权限修改需该账号重新登录后生效。</div>
              </el-form-item>
            </div>
          </el-form>
        </section>
      </div>

      <div slot="footer" class="dialog-footer">
        <span class="footer-tip"><i class="el-icon-info"></i> 账户信息保存后生效，权限修改需重新登录</span>
        <div class="dialog-btn-group">
          <el-button class="cancel-btn" @click="showInfo = false">取消</el-button>
          <el-button
            v-if="canEdit === 1"
            type="primary"
            icon="el-icon-check"
            class="save-btn"
            :loading="saving"
            :disabled="saving"
            @click="subUserEdit"
          >保存更改</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue'
import { getAccountPermission } from '../../utils/accountPermission'

export default {
  name: 'userIndex',
  components: {
    ManagementTable
  },
  data() {
    return {
      loading: false,
      saving: false,
      userLevel: 2,
      canEdit: 1,
      showInfo: false,
      formObject: {
        id: 0,
        userName: '',
        account: '',
        userMobile: '',
        userEmail: '',
        priceOfMoney: '',
        userNewPass: '',
        userNewPassConfirm: '',
        canEdit: 1,
        userLevel: null,
        createUserId: 0
      },
      query: {
        pageNum: 1,
        pageSize: 10,
        userName: ''
      },
      total: 0,
      tableData: []
    }
  },
  computed: {
    canSetPermission() {
      return this.canEdit === 1 && (this.formObject.id ? this.formObject.userLevel === 3 : this.userLevel > 1);
    }
  },
  mounted() {
    document.title = '智能叠光控制系统';
    // 从本地存储获取用户级别并做类型转换
    this.userLevel = Number(localStorage.getItem("a-xny-level")) || 2;
    this.canEdit = getAccountPermission();
    this.serch();
  },
  methods: {
    // 重置表单（弹窗关闭时调用，避免数据残留）
    resetForm() {
      this.saving = false;
      this.formObject = {
        id: 0,
        userName: '',
        account: '',
        userMobile: '',
        userEmail: '',
        priceOfMoney: '',
        userNewPass: '',
        userNewPassConfirm: '',
        canEdit: 1,
        userLevel: null,
        createUserId: 0
      };
    },
    // 删除账号
    doDelete(id) {
      this.$confirm('您确定要删除该账号吗？,请谨慎操作！', '温馨提醒', {
        customClass: 'a-confirm-p'
      }).then(_ => {
        this.$request.delete('/api/user/delete/' + id).then(response => {
          if (response.data.result) {
            this.$message.success("删除成功");
            this.serch();
          } else {
            this.$message.error(response.data.message || "删除失败");
          }
        }).catch(err => {
          this.$message.error("网络异常，删除失败！");
        })
      }).catch(_ => {})
    },
    // 表单提交（添加/编辑账号）
    async subUserEdit() {
      const isNewUser = !this.formObject.id;
      // 表单校验
      if (!this.formObject.userName) {
        this.$message.error('名称不能为空!');
        return;
      }
      if (!this.formObject.account) {
        this.$message.error('用户名不能为空!');
        return;
      }
      if (!this.formObject.userMobile) {
        this.$message.error('手机号不能为空!');
        return;
      }
      if (isNewUser && (!this.formObject.userNewPass || !this.formObject.userNewPass.trim())) {
        this.$message.error('密码不能为空!');
        return;
      }
      if (isNewUser && (!this.formObject.userNewPassConfirm || !this.formObject.userNewPassConfirm.trim())) {
        this.$message.error('请再次输入密码!');
        return;
      }
      if (isNewUser && this.formObject.userNewPass !== this.formObject.userNewPassConfirm) {
        this.$message.error('两次输入的密码不一致!');
        return;
      }
      const requestData = Object.assign({}, this.formObject);
      delete requestData.userNewPassConfirm;
      delete requestData.userLevel;
      if (!this.canSetPermission) delete requestData.canEdit;
      if (!isNewUser) {
        if (!requestData.userNewPass || !requestData.userNewPass.trim()) delete requestData.userNewPass;
      }
      this.saving = true;
      try {
        const response = await this.$request.post('/api/user/add', requestData);
        if (response.data.result) {
          this.$message.success(isNewUser ? "添加成功" : (this.canSetPermission ? "修改成功，权限修改需该账号重新登录后生效" : "修改成功"));
          this.showInfo = false;
          this.serch();
        } else {
          this.$message.error(response.data.message || "操作失败");
        }
      } catch (error) {
        const responseMessage = error && error.response && error.response.data && error.response.data.message;
        this.$message.error(responseMessage || (error && error.message) || "网络异常，操作失败！");
      } finally {
        this.saving = false;
      }
    },
    // 新增账号
    addUser() {
      this.resetForm(); // 新增前重置表单
      this.showInfo = true;
      this.formObject.id = 0;
    },
    // 使用数据副本编辑，取消时不影响列表中的原始内容
    openUserEdit(row) {
      this.formObject = {
        id: row.id,
        userName: row.userName || '',
        account: row.account || '',
        userMobile: row.userMobile || '',
        userEmail: row.userEmail || '',
        priceOfMoney: row.priceOfMoney,
        userNewPass: '',
        userNewPassConfirm: '',
        canEdit: Number(row.canEdit) === 2 ? 2 : 1,
        userLevel: Number(row.userLevel),
        createUserId: row.createUserId
      };
      this.showInfo = true;
    },
    // 查询（重置页码后加载）
    serch() {
      this.query.pageNum = 1;
      this.loadPage();
    },
    // 分页切换
    onPageChange(val) {
      this.query.pageNum = val
      this.loadPage()
    },
    // 加载账号列表分页数据
    loadPage() {
      this.loading = true;
      this.$request.post("/api/user/page", this.query).then(response => {
        if (response.data.result) {
          this.tableData = response.data.data.list || [];
          this.total = response.data.data.totalCount || 0;
        } else {
          this.$message.error("获取数据失败,请联系管理员!");
        }
      }).catch(err => {
        this.$message.error("网络异常，获取账号列表失败！");
      }).finally(() => {
        this.loading = false;
      })
    },
  }
}
</script>

<style scoped>
.user-manage-page {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.opt-btn {
  color: var(--solar-primary, #387AFC);
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s;
}

.opt-btn:hover,
.view-btn:hover {
  color: var(--solar-primary, #00CCFF);
}

.del-btn {
  color: var(--solar-danger, #FF6B6B);
  margin-left: 10px;
}

.del-btn:hover {
  color: var(--solar-danger, #FF4500);
}

.dialog-heading {
  display: flex;
  align-items: center;
  padding-right: 34px;
}

.dialog-heading strong {
  color: var(--solar-text-strong, #edfaff);
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.5px;
}

.form-content {
  display: block;
}

.form-panel {
  min-width: 0;
}

.section-heading {
  display: flex;
  margin-bottom: 16px;
  padding-bottom: 11px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(77, 167, 199, 0.14);
}

.section-heading > span {
  color: var(--solar-text-strong, #dff8ff);
  font-size: 14px;
  font-weight: 600;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 14px;
}

.permission-form-item {
  grid-column: 1 / -1;
}

.permission-radio-group {
  display: flex;
  min-height: 38px;
  align-items: center;
}

.permission-tip {
  margin-top: 4px;
  color: var(--solar-muted, #628fa2);
  font-size: 11px;
  line-height: 16px;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-tip {
  color: var(--solar-muted, #628fa2);
  font-size: 11px;
}

.footer-tip i {
  margin-right: 5px;
  color: var(--solar-primary, #3daed5);
}

.dialog-btn-group {
  display: flex;
  gap: 10px;
}

.dialog-btn-group .el-button {
  min-width: 88px;
  margin: 0;
  border-radius: 7px;
}

::v-deep .user-edit-dialog {
  overflow: hidden;
  border: 1px solid rgba(76, 193, 235, 0.3);
  border-radius: 16px;
  background: linear-gradient(145deg, var(--solar-surface, #062a45), var(--solar-page, #031b30));
  box-shadow: 0 28px 90px rgba(0, 5, 16, 0.64), inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

::v-deep .user-edit-dialog .el-dialog__header {
  padding: 18px 22px;
  border-bottom: 1px solid rgba(74, 177, 214, 0.16);
  background: rgba(var(--solar-page-rgb, 2, 24, 42), 0.66);
}

::v-deep .user-edit-dialog .el-dialog__headerbtn {
  top: 21px;
  right: 23px;
}

::v-deep .user-edit-dialog .el-dialog__close {
  color: var(--solar-muted, #6faabd);
  font-size: 18px;
  transition: color 0.2s ease, transform 0.2s ease;
}

::v-deep .user-edit-dialog .el-dialog__close:hover {
  color: var(--solar-text, #61ddff);
  transform: rotate(90deg);
}

::v-deep .user-edit-dialog .el-dialog__body {
  max-height: calc(84vh - 164px);
  padding: 22px;
  overflow-y: auto;
  color: var(--solar-text-strong, #cdeef6);
  background: transparent;
}

::v-deep .user-edit-dialog .el-dialog__footer {
  padding: 14px 22px 17px;
  border-top: 1px solid rgba(74, 177, 214, 0.15);
  background: rgba(var(--solar-page-rgb, 2, 22, 39), 0.48);
}

::v-deep .user-form .el-form-item {
  margin-bottom: 15px;
}

::v-deep .user-form .el-form-item__label {
  padding-bottom: 6px;
  color: var(--solar-text, #91c7d8);
  font-size: 12px;
  line-height: 18px;
}

::v-deep .user-form .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
  color: var(--solar-danger, #ff7182);
}

::v-deep .user-form .el-input__inner {
  height: 38px;
  padding-left: 34px;
  color: var(--solar-text-strong, #e1f7fc);
  border-color: rgba(68, 153, 188, 0.34);
  border-radius: 7px;
  background: rgba(var(--solar-page-rgb, 0, 20, 36), 0.66);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

::v-deep .user-form .el-input__inner::placeholder {
  color: #4f7d90;
}

::v-deep .user-form .el-input__inner:hover {
  border-color: rgba(71, 190, 229, 0.58);
}

::v-deep .user-form .el-input__inner:focus {
  border-color: var(--solar-border-strong, #2fbae8);
  background: rgba(var(--solar-page-rgb, 0, 25, 44), 0.86);
  box-shadow: 0 0 0 3px rgba(var(--solar-primary-rgb, 34, 171, 220), 0.1);
}

::v-deep .user-form .el-input__prefix,
::v-deep .user-form .el-input__suffix {
  color: var(--solar-muted, #4da9c6);
}

::v-deep .permission-radio-group .el-radio {
  color: var(--solar-text, #91c7d8);
}

::v-deep .permission-radio-group .el-radio__inner {
  border-color: rgba(68, 153, 188, 0.58);
  background: rgba(var(--solar-page-rgb, 0, 20, 36), 0.66);
}

::v-deep .permission-radio-group .el-radio__input.is-checked .el-radio__inner {
  border-color: var(--solar-border-strong, #20bce8);
  background: var(--solar-primary, #20bce8);
}

::v-deep .permission-radio-group .el-radio__input.is-checked + .el-radio__label {
  color: var(--solar-text, #61ddff);
}

::v-deep .user-form .el-input-group__append {
  padding: 0 12px;
  color: var(--solar-muted, #75b6ca);
  border-color: rgba(68, 153, 188, 0.34);
  background: rgba(var(--solar-raised-rgb, 10, 55, 78), 0.7);
}

::v-deep .dialog-btn-group .cancel-btn {
  color: var(--solar-text, #91c7d8);
  border-color: rgba(76, 159, 190, 0.34);
  background: rgba(var(--solar-surface-rgb, 8, 49, 72), 0.48);
}

::v-deep .dialog-btn-group .cancel-btn:hover {
  color: var(--solar-text-strong, #d8f7ff);
  border-color: rgba(79, 199, 236, 0.56);
  background: rgba(var(--solar-raised-rgb, 13, 72, 100), 0.62);
}

::v-deep .dialog-btn-group .save-btn {
  color: var(--solar-text-strong, #fff);
  border-color: var(--solar-border-strong, #179fd8);
  background: linear-gradient(135deg, var(--solar-primary, #20bce8), var(--solar-primary, #1788d5));
  box-shadow: 0 6px 16px rgba(var(--solar-primary-rgb, 0, 126, 195), 0.28);
}

::v-deep .dialog-btn-group .save-btn:hover {
  border-color: var(--solar-border-strong, #38ccf3);
  background: linear-gradient(135deg, var(--solar-primary, #35caf0), var(--solar-primary, #1999df));
  box-shadow: 0 8px 20px rgba(var(--solar-primary-rgb, 0, 139, 207), 0.36);
}

@media (max-width: 760px) {
  /* 消除移动端右侧固定操作列与表格边缘之间的渲染接缝。 */
  ::v-deep .user-index-table .el-table__fixed-right {
    right: 0 !important;
    background-color: var(--solar-surface, #002b4d) !important;
  }

  ::v-deep .user-index-table .el-table__fixed-right::after {
    position: absolute;
    z-index: 4;
    top: 0;
    right: -1px;
    bottom: 0;
    width: 2px;
    background-color: var(--solar-surface, #002b4d);
    content: '';
    pointer-events: none;
  }

  ::v-deep .user-edit-dialog {
    width: calc(100% - 28px) !important;
    margin-top: 4vh !important;
  }

  ::v-deep .user-edit-dialog .el-dialog__body {
    max-height: calc(92vh - 164px);
    padding: 18px;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .dialog-footer {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }

  .footer-tip {
    text-align: left;
  }

  .dialog-btn-group {
    justify-content: flex-end;
  }
}

</style>
